var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5.75C5.86193 5.75 5.75 5.86193 5.75 6V26C5.75 26.1381 5.86193 26.25 6 26.25H26C26.1381 26.25 26.25 26.1381 26.25 26V6C26.25 5.86193 26.1381 5.75 26 5.75H6ZM4.25 6C4.25 5.0335 5.0335 4.25 6 4.25H26C26.9665 4.25 27.75 5.0335 27.75 6V26C27.75 26.9665 26.9665 27.75 26 27.75H6C5.0335 27.75 4.25 26.9665 4.25 26V6Z",
    fill: "#383733"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 2.25C22.4142 2.25 22.75 2.58579 22.75 3V7C22.75 7.41421 22.4142 7.75 22 7.75C21.5858 7.75 21.25 7.41421 21.25 7V3C21.25 2.58579 21.5858 2.25 22 2.25Z",
    fill: "#383733"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 2.25C10.4142 2.25 10.75 2.58579 10.75 3V7C10.75 7.41421 10.4142 7.75 10 7.75C9.58579 7.75 9.25 7.41421 9.25 7V3C9.25 2.58579 9.58579 2.25 10 2.25Z",
    fill: "#383733"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.25 11C4.25 10.5858 4.58579 10.25 5 10.25H27C27.4142 10.25 27.75 10.5858 27.75 11C27.75 11.4142 27.4142 11.75 27 11.75H5C4.58579 11.75 4.25 11.4142 4.25 11Z",
    fill: "#383733"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.abebf87f70d91127be94e711939049b9.svg";
export { ForwardRef as ReactComponent };